<template>
  <div class="login02">
    <a href="javascript:void(0)" class="logo">
      <img class="pc-logo" src="@/assets/images/logo-text.png" alt />
      <img class="mobile-logo" src="@/assets/images/logo-text.png" alt />
    </a>
    <div class="login_bar"></div>
    <div class="login_inner02">
      <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" class="login_form login_form02">
        <h2 class="login-h2">欢迎登录</h2>
        <el-form-item class="el-form-item-login" prop="username"><el-input
            type="text"
            auto-complete="off"
            placeholder="账号"
            v-model="loginForm.username"
          ></el-input>
        </el-form-item>
        <el-form-item class="el-form-item-login" prop="password">
          <el-input
            type="password"
            auto-complete="off"
            placeholder="密码"
            v-model="loginForm.password"
          ></el-input>
        </el-form-item>
        <el-form-item class="el-form-item-login" prop="imgCode">
          <el-input
            type="text"
            auto-complete="off"
            placeholder="验证码"
            class="verifycode"
            v-model="loginForm.imgCode"
          >
            <img slot="append" class="login-img-code" :src="codeSrc" @click="nextImg"/>
          </el-input>
        </el-form-item>
        <el-form-item class="el-form-item-login" style="width:100%;margin-top:50px">
          <el-button class="login_form_button" :loading="loading" @click="login">
            <span>
              登 录
              <span v-if="loading">中...</span>
            </span>
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="login_bottom02">
      <p>京公网安备 11010502031033号 京ICP备05034014号-10</p>
    </div>
  </div>
</template>

<script>
import uuid from 'uuid/v4'
import { getCodeImg } from '@/api/common'

export default {
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
        imgCode: '',
        uuid: ''
      },
      loginFormRules: {
        username: [
          { required: true, trigger: 'blur', message: '用户名不能为空' }
        ],
        password: [
          { required: true, trigger: 'blur', message: '密码不能为空' }
        ],
        imgCode: [
          { required: true, trigger: 'blur', message: '验证码不能为空' }
        ]
      },
      loading: false,
      codeSrc: null
    }
  },
  methods: {
    initCode() {
      const __uuid = uuid()

      getCodeImg(__uuid).then((res) => {
        this.codeSrc = `data:image/gif;base64,${res.data}`
        this.loginForm.uuid = __uuid
      })
    },
    nextImg() {
      const __uuid = uuid()

      getCodeImg(__uuid).then((res) => {
        this.codeSrc = `data:image/gif;base64,${res.data}`
        this.loginForm.uuid = __uuid
      })
    },
    login() {
      this.$refs.loginFormRef.validate((valid) => {
        if (valid) {
          this.loading = true

          this.$store
            .dispatch('login', this.loginForm)
            .then(res => {
              if (res.status === 2) {
                this.loginForm.imgCode = null
                this.initCode()
                this.$message.error(res.msg)
              } else {
                this.$message.success('登录成功')
                this.$router.push('/dashboard')
              }
              this.loading = false
            })
        }
      })
    },
    enterLogin(e) {
      if (e.keyCode === 13) {
        this.login()
      }
    }
  },
  created() {
    window.addEventListener('keydown', this.enterLogin)
    this.initCode()
  }
}
</script>

<style lang="scss" scoped>
.login_box {
  width: 500px;
  margin: 100px auto;
  h2 {
    font-size: 20px;
    line-height: 30px;
    padding-bottom: 20px;
  }
}

.login-img-code {
  display: block;
  width: 110px;
  margin: 0 -20px;
}
</style>
